import { McAction } from '../IMcAction';
import initialState, { IQcPlanDetailState } from '../modules/qc-plan/IQcPlanDetailState';
import { GET_QC_PLAN_DETAIL } from '../modules/qc-plan/qc-plan.action.const';
import { getQcPlanDetailState } from '../modules/qc-plan/qc-plan.reducer.logic';

export function qcPlanDetailReducer(state: IQcPlanDetailState = initialState, action: McAction) {
    switch (action.type) {
        case GET_QC_PLAN_DETAIL:
            return getQcPlanDetailState(state, action);

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/qc-plan-detail.reducer.ts